module.exports = __webpack_public_path__ + "static/media/moneyPic.c5e7b95f.png";